import { useEffect, useMemo, useState } from 'react';
import { useAddAccountStore, useAddCardStore, useDictionariesStore } from '@lib/store';
import { AddItemEnum } from '@shared/api';
import { Button, ItemsType, Modal, Select } from '@shared/widgets';

interface AddNewItemModalProps {
  isOpen: boolean;
  onClose: () => void;
  type: AddItemEnum;
}

export const AddNewItemModal = (props: AddNewItemModalProps) => {
  const dictionariesStore = useDictionariesStore();
  const addAccountStore = useAddAccountStore();
  const addCardStore = useAddCardStore();

  const [selectedCurrency, setSelectedCurrency] = useState<ItemsType>();

  useEffect(() => {
    if (dictionariesStore.data?.Currency && dictionariesStore.data.Currency.length > 0) {
      const allowedCurrencies =
        props.type === AddItemEnum.Card
          ? dictionariesStore.data.Currency.filter((c) => c.Name === 'USD' || c.Name === 'EUR')
          : dictionariesStore.data.Currency;
      const firstCurrency = allowedCurrencies[0];
      setSelectedCurrency({ value: firstCurrency.Id, leftLabel: firstCurrency.Name });
    }
  }, [dictionariesStore.data, props.type]);

  const applyHandler = async () => {
    if (!selectedCurrency) return;
    if (props.type === AddItemEnum.Account) await addAccountStore.addAccount({ Currency: selectedCurrency.value });
    if (props.type === AddItemEnum.Card) await addCardStore.addCard({ Currency: selectedCurrency.value });
    props.onClose();
  };

  const currencyOptions = useMemo(() => {
    const currencies = dictionariesStore.data?.Currency || [];
    const allowedCurrencies = props.type === AddItemEnum.Card ? currencies.filter((c) => c.Name === 'USD' || c.Name === 'EUR') : currencies;
    return allowedCurrencies.map((item) => ({ leftLabel: item.Name, value: item.Id }));
  }, [dictionariesStore.data, props.type]);
  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose} title={`Apply for a New ${props.type === AddItemEnum.Account ? 'Account' : 'Card'}`}>
      <div className='mt-2 flex w-full flex-col gap-7'>
        <div className='text-center text-sm font-semibold text-[#666] uppercase'>Choose Currency</div>
        <Select items={currencyOptions} value={selectedCurrency?.value} onChange={(value) => setSelectedCurrency(value)} />
      </div>
      <div className='mt-4 flex w-full flex-col gap-4'>
        <Button fullWidth color='primary' disabled={addAccountStore.loading || addCardStore.loading} onClick={applyHandler}>
          Apply
        </Button>
        <Button fullWidth color='outlined' onClick={props.onClose}>
          Cancel
        </Button>
      </div>
    </Modal>
  );
};
